import CRUDService from '@/services/hrsg/CRUDService';

export class ReviewAdministratorService extends CRUDService {
  constructor () {
    super('reviews.administrators');
  }
}

export default new ReviewAdministratorService();
